<atn-ds-widget title="General">
  <ng-container actions>
    @if (canEditTenantSg()) {
      <i
        class="atn-icon atn-edit atn-blue"
        (click)="editClickHandler()"
      ></i>
    }
  </ng-container>
  <div class="atn-tenant-general-tab">
    <div
      class="atn-tenant-general-tab__field"
      data-test-id="name-field"
    >
      <span><b>Name</b></span>
      <atn-ds-value [value]="nameSg()" />
    </div>
    <div
      class="atn-tenant-general-tab__field"
      data-test-id="alias-field"
    >
      <span><b>Alias</b></span>
      <atn-ds-value [value]="aliasSg()" />
    </div>
    <div
      class="atn-tenant-general-tab__field"
      data-test-id="code-field"
    >
      <span><b>Code</b></span>
      <atn-ds-value [value]="codeSg()" />
    </div>

    <div
      class="atn-tenant-general-tab__field"
      data-test-id="color-field"
    >
      <span><b>Theme Color</b></span>
      <!-- TODO consider integrating color display into atn-ds-value -->
      <div
        class="atn-tenant-general-tab__color"
        [style.background]="colorSg() ?? 'transparent'"
      ></div>
    </div>
  </div>
</atn-ds-widget>

<atn-admin-tenant-modal />
